/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchUserCarrierSelectionsRequestActionCreator, deleteUserCarrierSelectionRequestActionCreator } from '../../../user/redux/actions/UserActions';
import { carrierCheckedActionCreator } from '../redux/actions/CarrierActions';
import Icons from '../../../../core/modules/common/components/Icons';
import DeleteModal from '../../../common/components/DeleteModal';

const mapStateToProps = state => ({
  selections: state.carrierSelector.carrier.selections,
});

export class CarrierSelectionSidebarContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSelection: 'Your last selection',
      showDeleteSelectionModal: false,
      name: '',
    };
  }

  componentDidMount() {
    this.props.fetchUserCarrierSelectionsRequestActionCreator();
  }

  onCloseModal = () => {
    this.setState({
      showDeleteSelectionModal: false,
    });
  };

  applySelection = (e, selection) => {
    this.props.carrierCheckedActionCreator(selection.carriers);
    this.setState({
      activeSelection: selection.name,
    });
  };

  openDeleteSelectionModal = (e, selection) => {
    this.setState({
      showDeleteSelectionModal: true,
      name: selection.name,
    });
  };

  deleteSelection = () => {
    this.props.deleteUserCarrierSelectionRequestActionCreator(this.state.name);
    this.onCloseModal();
  };

  render() {
    const {
      selections,
    } = this.props;
    return (
      <div className="operator-sidebar-div">
        <div className="selection-title">
          <FormattedMessage
            tagName="h5"
            id="app.selection.list.title.carrier"
          />
        </div>
        {selections && selections.length > 0 ? (
          <div className="user-selections">
            {this.state.showDeleteSelectionModal &&
              <DeleteModal
                headerFormattedMessageId="app.warning.delete.save.operator.selection"
                onCloseModal={this.onCloseModal}
                deleteSelection={this.deleteSelection}
              />
            }
            <ul>
              { selections
                  .filter(selection => selection.name !== 'Your last selection')
                  .map(selection => (
                    <li
                      key={selection.name}
                      onClick={e => this.applySelection(e, selection)}
                      className={this.state.activeSelection === selection.name ? 'active' : ''}
                    >
                      <button
                        className="delete-icon"
                        key={selection.name}
                        onClick={e => this.openDeleteSelectionModal(e, selection)}
                      >
                        <Icons.Custom name="trash-o" />
                      </button>
                      {selection.name}
                    </li>
              )) }
            </ul>
          </div>
          ) :
          <FormattedMessage id="app.selection.list.empty" />
        }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchUserCarrierSelectionsRequestActionCreator,
  deleteUserCarrierSelectionRequestActionCreator,
  carrierCheckedActionCreator,
}, dispatch);

CarrierSelectionSidebarContainer.propTypes = {
  selections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    carriers: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  fetchUserCarrierSelectionsRequestActionCreator: PropTypes.func,
  deleteUserCarrierSelectionRequestActionCreator: PropTypes.func,
  carrierCheckedActionCreator: PropTypes.func,
};

export const ConnectedCarrierSelectionSidebarContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CarrierSelectionSidebarContainer);

export default (ConnectedCarrierSelectionSidebarContainer);
